import script from "./SideNav.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNav.vue?vue&type=script&setup=true&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=17fc0f8a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17fc0f8a"]])

export default __exports__